<template>
  <div class="login-bg-img">
    <div class="login-content">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          size=" "
          class="demo-ruleForm"
        >
          <el-form-item style="color: aliceblue" label="账号" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="pwd">
            <el-input v-model="ruleForm.pwd" show-password></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              style="width: 50%; height: 50px; font-size: 18px"
              size="medium"
              @click="submitForm('ruleForm')"
              @keyup.enter="keyDown(e)"
              >立即登录</el-button
            >
          </el-form-item>
        </el-form>
        <div
          style="
            color: #fff;
            margin-top: 12%;
            text-align: center;
            font-size: 16px;
            position: relative;
            right: -25%;
            top: 30px;
          "
        >
          &copy; 2023 Gansu Smart Agriculture. 大行
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserList } from "../../server/index.js";
export default {
  name: "app",
  components: {},
  data() {
    return {
      ruleForm: {
        name: "",
        pwd: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
          {
            min: 3,
            max: 1000,
            message: "长度在 3 到 1000 个字符",
            trigger: "blur",
          },
        ],
        pwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    const style = `
	  background-color: #55ff7f;
	  color: #ffffff`;
    console.log("%c大行农业", style);
    let state = this.$route.query.state;
    console.log("%c大行农业state", state);
    if (state == 1) {
      alert("登录状态已过期，请重新登录");
      window.location.href = "https://web.dxnyyun.com/large_screen/#/loginPage";
    }
    // this.getUserList();
    window.addEventListener("keydown", this.keyDown); //监听回车事件
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false); //销毁回车事件，如果不销毁，在其他页面敲回车也会执行回车登录操作。
  },
  methods: {
    keyDown(e) {
      // console.log("e", e.keyCode);
      if (e.keyCode == 13 || e.keyCode == 100) {
        this.submitForm("ruleForm"); //自己的登录方法
      }
    },
    submitForm(formName) {
      let timeKey = Date.now();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            username: this.ruleForm.name,
            password: this.ruleForm.pwd,
            type: "C",
            key: timeKey,
          };
          console.log("params===", params);
          this.$axios
            .post("/user/login", params)
            .then((res) => {
              console.log("登录-res===", res);
              if (res.code == 500) {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              } else {
                res.data.key = timeKey;
                localStorage.setItem("user_info", JSON.stringify(res.data));
                this.$message({
                  message: "登录成功",
                  type: "success",
                });
                setTimeout(() => {
                  this.$router.replace("/init");
                }, 3000);
              }
            })
            .catch((error) => {
              console.log("登录-error===", error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getUserList() {
      let httpData = {};
      getUserList(httpData)
        .then((res) => {
          console.log("getTaskList", res);
        })
        .catch((err) => {
          console.log("message", err);
          return;
        });
    },
  },
};
</script>

<style>
.login-bg-img {
  width: 100%;
  height: 100%;
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1721096745384.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.login-content {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  right: 21%;
  top: 3%;
}

.el-form-item {
  margin-top: 12%;
}

.el-form-item__label {
  color: #fff;
  font-size: 20px;
}

.el-input__inner {
  font-size: 20px;
  height: 55px;
  line-height: 55px;
  width: 150%;
}

.el-form-item__error {
  font-size: 16px;
}

.el-input__suffix {
  right: -45%;
  transition: all 0.3s;
  pointer-events: none;
}
</style>
